export interface AppConfig {
  apiBaseUrl: string;
  apiAuthBaseUrl: string;
  apiSupportBaseUrl: string;
  environmentLabel: string;
  connectionTestCooldownMinutes: number;
}

const toNumber = (value: string | undefined, fallback: number) => {
  if (!value) return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const baseUrl = (import.meta.env.VITE_API_BASE_URL?.trim() || '/internal/dashboard/sms').replace(
  /\/+$/,
  ''
);

const inferAuthBaseUrl = () => {
  const override = import.meta.env.VITE_API_AUTH_BASE_URL?.trim();
  if (override) return override.replace(/\/+$/, '');

  if (baseUrl.endsWith('/sms')) {
    return `${baseUrl.slice(0, -4)}/auth`;
  }
  return `${baseUrl}/auth`;
};

const inferSupportBaseUrl = () => {
  const override = import.meta.env.VITE_API_SUPPORT_BASE_URL?.trim();
  if (override) return override.replace(/\/+$/, '');
  const trimmed = baseUrl;
  return `${trimmed}/support`;
};

export const config: AppConfig = {
  apiBaseUrl: baseUrl,
  apiAuthBaseUrl: inferAuthBaseUrl(),
  apiSupportBaseUrl: inferSupportBaseUrl(),
  environmentLabel: import.meta.env.VITE_ENVIRONMENT_LABEL?.trim() || 'Local',
  connectionTestCooldownMinutes: toNumber(import.meta.env.VITE_CONNECTION_TEST_COOLDOWN_MINUTES, 30)
};
